// @flow
import React from 'react';
import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import useNow from '../../../hooks/useNow';

const HIGH = 51;
const MEDIUM = 25;

const useStyles = makeStyles({
    root: {
        marginRight: '.5ch',
        borderRadius: '50%',
        overflow: 'hidden',
    },
    circle: {
        fill: '#aaaaaa',
        strokeWidth: '44px'
    },
    circleGreen: {
        stroke: '#417505'
    },
    circleYellow: {
        stroke: '#F5A623'
    },
    circleRed: {
        stroke: '#D0041B'
    }
});

type Props = $ReadOnly<{
    timestamp: ?number,
    duration: number
}>;
function Timer({ timestamp, duration }: Props) {
    const classes = useStyles();
    const now = useNow();

    const elapsed = timestamp && Math.min(now - timestamp, duration);
    const percent = elapsed ? ((elapsed / duration) * 100) : 100;
    const value = 100 - percent;

    return (
        <CircularProgress
            variant="static"
            classes={{
                root: classes.root,
                circle: classnames(classes.circle, {
                    [classes.circleGreen]: value >= HIGH,
                    [classes.circleYellow]: value < HIGH && value >= MEDIUM,
                    [classes.circleRed]: value < MEDIUM && value > 0
                })
            }}
            value={value}
            size={16}
            thickness={0}
        />
    );
}

export default Timer;